import React, { ReactElement } from 'react'
import { Flex, Image, Text, ThemeUIStyleObject } from 'theme-ui'
import UfoIcon from 'images/ufo.png'
import LogoNotFoundIcon from 'images/logos/not-found.svg'
import { Button, Svg } from 'ui'
import { RouteComponentProps } from '@reach/router'
import { navigate } from 'gatsby'

const NotFound = ({ sx }: RouteComponentProps<{ sx?: ThemeUIStyleObject }>): ReactElement => {
  return (
    <Flex
      sx={{
        width: '100%',
        position: 'fixed',
        height: '100%',
        top: 0,
        left: 0,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        backgroundColor: 'darkBodyBG',
        gap: '3.3rem',
        ...sx,
      }}
      data-testid="not-found-container"
    >
      <Flex
        sx={{
          flexDirection: 'column',
          alignItems: 'center',
          gap: '4.8rem',
        }}
      >
        <Flex
          sx={{
            gap: '0.8rem',
            alignItems: 'center',
          }}
        >
          <Svg
            data-testid="not-found-logo"
            svg={LogoNotFoundIcon}
            descriptiveText="Control D logo on 404 page"
          />
          <Text color="title" variant="size18Weight800Line140">
            CONTROL D
          </Text>
        </Flex>
        <Image
          data-testid="not-found-icon"
          alt="not found image"
          src={UfoIcon}
          sx={{ width: '25.8rem' }}
        />
      </Flex>
      <Text
        color="title"
        variant="size16Weight500Line140Letter008"
        sx={{
          maxWidth: '25.8rem',
        }}
        data-testid="not-found-text"
      >
        Oops! The page you&apos;re looking for has been abducted.
      </Text>
      <Button
        ariaLabel="Go Home"
        name="Go Home"
        data-testid="go-home-button"
        variant="roundedSecondary"
        onClick={() => navigate('/')}
      >
        <Text color="title">Go Home</Text>
      </Button>
    </Flex>
  )
}

export default NotFound
